import Vue from 'vue';
import store from '@/store';
import dayjs from 'dayjs';
// import { ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full.esm';


// Register it globally
// Vue.component('ValidationProvider', ValidationProvider);
// Vue.component('ValidationObserver', ValidationObserver);

import { extend, localize, ValidationProvider, ValidationObserver } from "vee-validate";
import { min_value, max_value, numeric, required, email, confirmed, ext } from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";

// Install rules
extend("required", required);
extend("email", email);
extend("confirmed", confirmed);
extend("min_value", min_value);
extend("max_value", max_value);
extend("numeric", numeric);
extend("ext", ext);
extend("date", {
  message: 'Invalid date',
  validate(date) {
    return date instanceof Date && !isNaN(date);
  },
});
extend('expiredInspection', {
  message: 'An inspection with this date is already expired.',
  validate: (date) => {
    let now = dayjs();
    let twoYearsAgo = now.subtract(2, 'years');
    let feb012020 = dayjs('2020-02-01');

    if (twoYearsAgo.isBefore(feb012020)) {
      return dayjs(date).isAfter(twoYearsAgo);
    } 
    let fourYearsAgo = now.subtract(4, 'years');
    if (fourYearsAgo.isBefore(feb012020)) {
      return dayjs(date).isAfter(feb012020);
    } 
    return dayjs(date).isAfter(fourYearsAgo);
  },
});
extend("validFigure", {
  message: 'This section must be completed',
  validate: (figure) => {
    if (!figure) {
      console.log(figure, false);
      return false;
    }

    if ([ 'front', 'middle', 'rear', '' ].indexOf(figure.location) === -1) {
      console.log(figure, false);
      return false;
    }

    if ([ 'window', 'no-window', 'control', 'floor' ].indexOf(figure.type) === -1) {
      console.log(figure, false);
      return false;
    }

    if (typeof figure.roomNumber !== 'number' || typeof figure.value !== 'number') {
      console.log(figure, false);
      return false;
    }

    console.log("figure ok");
    return true;
  },
});

extend("uniqueUnit", { 
  message: 'This unit name already exists, please change it to avoid losing your information.',
  validate: (value) => {
    let found = store.state.properties.allInspectionsNames
      .filter(name => String(name).toLowerCase() === String(value).toLowerCase());
    return found.length <= 1;
  },
});

extend("correctUnit", { 
  message: 'Please insert a correct unit name, it shouldn\'t be only a designator.',
  validate: (value) => {
    return !!String(value).replace(/^UNIT|DEPT|APT|BLDG|FL|STE|RM/, '').trim();
  },
});

extend("isPhilaGov", {
  message: 'The email is not a City Of Philadelphia issued one.',
  validate(value) {
    if(String(value).indexOf("@phila.gov", String(value).length - "@phila.gov".length) !== -1){
      return true;
    }
    return false;
  },
});

// Install messages
localize({
  en,
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
